import { twJoin } from "tailwind-merge";

type SkeletonProps = {
  width?: `w-${number}` | `w-${number}/${number}` | "w-full";
  height?: `h-${number}` | `h-${number}/${number}` | "h-full";
  rounded?: "rounded-full" | "rounded-lg";
  dataLoc?: string;
};

export const Skeleton: React.FC<SkeletonProps> = ({
  width = "w-full",
  height,
  rounded,
  dataLoc,
}) => (
  <div
    className={twJoin(
      "relative overflow-hidden rounded bg-gray-100",
      width,
      height,
      rounded,
    )}
    data-loc={dataLoc}
    role="status"
  >
    <div
      className="absolute inset-0 -translate-x-full transform bg-gradient-to-r from-gray-100 via-gray-50 to-gray-100"
      style={{ animation: "shimmer 1s infinite" }}
    ></div>
  </div>
);
